import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthToken, getAuthToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null); // { user, organisation }
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    setLoading(true);setError('');
    if (!getAuthToken()) { setSession(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setSession(data);
    } catch (err) {
      if (err?.response?.status === 401) {setAuthToken(null);setSession(null);}
      else setError('Could not connect to SmartQuote. Your sign-in has been kept.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setAuthToken(data.token);
    setSession({ user: data.user, organisation: data.organisation });
    return data;
  }, []);
  const activate = useCallback(async(token,password)=>{
    const {data}=await api.post('/auth/activate',{token,password});
    setAuthToken(data.token);setSession({user:data.user,organisation:data.organisation});setError('');
    return data;
  },[]);

  const logout = useCallback(() => {
    setAuthToken(null);
    setSession(null);
  }, []);

  return (
    <AuthCtx.Provider value={{ session, loading, error, login, activate, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}
